<template>
  <div>
    <v-row v-if="headerCheck">
      <v-checkbox
        v-model="initHeaderCheckbox"
        hide-details
        class="shrink mr-2 mt-0"
        @click.native.stop
        @change="(e) => $emit('headerCheckboxChange', e)"
        :ripple="false"
      >
        <template v-slot:label>
          <div>
            <b>{{ headerCheckText }}</b>
          </div>
        </template>
      </v-checkbox>
    </v-row>
    <v-row class="section-title-bar-inner-wrapper" no-gutters>
      <v-col class="d-flex align-center">
        <span class="section-title-text">{{ sectionTitle }}</span>
        <slot name="section-title"></slot>
      </v-col>

      <div v-if="displayTime">
        <v-select
          class="lesson-plan-time lesson-plan-time-select"
          v-on:change="(val) => $emit('set-timer-input', val)"
          @click="
            (event) => {
              event.stopPropagation();
            }
          "
          :rules="[(v) => !!v || Errors.REQUIRED_FIELD]"
          :items="allowedTimeValues"
          :value="time"
          placeholder="Select time"
          background-color="white"
          hide-details
          :disabled="!canEditTime"
          prepend-inner-icon="mdi-clock-outline"
          solo
          flat
        ></v-select>
      </div>

      <div v-if="displayTrailing && toggleComments" class="section-type-select-wrapper">
        <v-select
          class="section-type-select-field"
          v-on:change="(val) => $emit('update-type-of-block-to-state', val)"
          @click="
            (event) => {
              event.stopPropagation();
            }
          "
          :rules="[(v) => (v && v.length > 0) || Errors.REQUIRED_FIELD]"
          :items="schema.types || []"
          :value="types"
          placeholder="Select types"
          background-color="white"
          hide-details
          :disabled="!canEditType"
          solo
          flat
          multiple
        ></v-select>
      </div>
      <div class="comments-button-wrapper" v-if="displayComments && toggleComments">
        <v-btn @click.stop="toggleComments" class="comment-btn">
          <span style="color: #fff">COMMENT</span>
        </v-btn>
      </div>
    </v-row>
  </div>
</template>

<script>
import Errors from '@/constants/Errors';

export default {
  name: 'ExpansionPanelHeader',
  data: () => {
    return {
      Errors,
      initHeaderCheckbox: false,
      sectionSwitch: false,
    };
  },
  created() {
    this.initHeaderCheckbox = this.initialHeaderCheckValue;
  },
  props: {
    toggleComments: {
      type: Function,
      required: false,
    },
    sectionTitle: {
      type: String,
      required: true,
    },
    canEditType: {
      type: Boolean,
      required: false,
      default: false,
    },
    time: {
      type: String,
      default: '',
    },
    displayTrailing: {
      type: Boolean,
      default: true,
      required: false,
    },
    displayComments: {
      type: Boolean,
      default: true,
      required: false,
    },
    displayTime: {
      type: Boolean,
      default: false,
      required: false,
    },
    canEditTime: {
      type: Boolean,
      default: false,
    },
    allowedTimeValues: {
      type: Array,
      required: false,
      default: () => [],
    },
    headerCheck: {
      type: Boolean,
      default: false,
    },
    headerCheckText: {
      type: String,
      default: '',
    },
    initialHeaderCheckValue: {
      type: Boolean,
      default: false,
    },
    types: {
      type: Array,
      default: () => [],
    },
    schema: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
  },
};
</script>

<style>
.lesson-plan-time-select {
  padding-top: 0px !important;
  margin-top: 0px !important;
  width: 150px;
  font-size: 16px !important;
}
.lesson-plan-time-select .v-input__control {
  min-height: 40px !important;
}
.section-title-text {
  font-weight: 500;
  text-transform: uppercase;
  font-size: 20px;
  display: flex;
  align-items: center;
}
.section-title-bar-inner-wrapper {
  display: flex;
  align-items: center;
}
.align-center-switch {
  margin-top: 2px;
}
.comment-btn {
  background-color: #177eee !important;
  font-weight: 500;
  font-size: 18px;
  height: 40px !important;
  float: right;
  box-shadow: none;
  border-radius: 2px;
  width: 170px;
  height: 40px;
}
.section-type-select-field {
  width: 270px;
  height: 40px;
}
.section-type-select-field .v-input__control {
  min-height: 40px !important;
}
.lesson-plan-time-wrapper {
  background-color: #d1d1d1;
  height: 40px;
  width: 150px;
  margin-left: 10px;
  color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.section-type-select-wrapper {
  margin-left: 30px;
  overflow: hidden;
}
.comments-button-wrapper {
  margin-left: 30px;
}
</style>
